import React, { FunctionComponent } from 'react';
import Hint from 'src/ui/atoms/hint';
import Translate from 'src/ui/atoms/translate';
import { Modal, ModalContent, ModalFooter, ModalFooterButtons, ModalHeader } from 'src/ui/molecules/modal';

const EmailResentSuccess: FunctionComponent<{ email: string; onClose: () => void }> = ({ email, onClose }) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="issuerPermissionsUserDetails.resendEmailSuccessModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate
            as="span"
            name="issuerPermissionsUserDetails.resendEmailSuccessModal.hint"
            args={[<b>{email}</b>]}
          />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          align="end"
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: onClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default EmailResentSuccess;
